module.exports = __webpack_public_path__ + "img/settings_remote.66affb03.svg";